"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _main = _interopRequireDefault(require("./main"));

var _DataBind = _interopRequireDefault(require("../DataBind"));

var _themeOptimized = _interopRequireDefault(require("../themeOptimized"));

var _react = _interopRequireWildcard(require("react"));

var _mergeTheme = _interopRequireDefault(require("../style/mergeTheme"));

var withFork = function withFork(themeOverride) {
  var ForkThemeMiddleware = _react["default"].forwardRef(function (_ref, ref) {
    var theme = _ref.theme,
        rest = (0, _objectWithoutProperties2["default"])(_ref, ["theme"]);
    var forkedTheme = (0, _react.useMemo)(function () {
      return (0, _mergeTheme["default"])(theme, themeOverride);
    }, [theme]);
    return _react["default"].createElement(_main["default"], (0, _extends2["default"])({
      theme: forkedTheme,
      ref: ref
    }, rest));
  });

  var WithForkedTheme = (0, _themeOptimized["default"])(ForkThemeMiddleware, 'input');
  var Bound = (0, _DataBind["default"])(WithForkedTheme);

  var Fork = _react["default"].forwardRef(function (_ref2, ref) {
    var bind = _ref2.bind,
        rest = (0, _objectWithoutProperties2["default"])(_ref2, ["bind"]);
    return bind ? _react["default"].createElement(Bound, (0, _extends2["default"])({}, rest, {
      bind: true
    })) : _react["default"].createElement(WithForkedTheme, (0, _extends2["default"])({}, rest, {
      ref: ref
    }));
  });

  Fork.displayName = "Fork(Input)";
  return Fork;
};

var _default = withFork;
exports["default"] = _default;